import { useSuspenseQuery } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { getDomain } from "../data/data-layer";
import { DomainGetDomains200DataItem } from "../gen/model";

const DomainContext = createContext<{
  domainName: string;
  domain: DomainGetDomains200DataItem;
}>({
  domainName: "must be provided",
  domain: {},
});

export default function DomainContextProvider({
  children,
  domainName,
}: {
  children: React.ReactNode;
  domainName: string;
}) {
  const { data } = useSuspenseQuery(getDomain(domainName));

  const domain = data.data[0];
  return (
    <DomainContext value={{ domainName, domain }}>{children}</DomainContext>
  );
}

export function useDomain() {
  const context = useContext(DomainContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
